import script from "./TenantApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./TenantApp.vue?vue&type=script&setup=true&lang=ts"

import "./TenantApp.vue?vue&type=style&index=0&id=37cba7b3&lang=scss"

const __exports__ = script;

export default __exports__